import React, { Component, Fragment } from "react"
import { connect } from "react-redux"
import { bindActionCreators, compose } from "redux"
import { withRouter } from "react-router-dom"
import cx from "classnames"
import ReactTooltip from "react-tooltip"
import "./index.scss"
import { formatTimestamp } from "helpers/util"
import CheckBox from "../checkbox"
import Comment from "../comment"
import Avatar from "components/common/Avatar"
import { isEmpty } from "lodash"

import { FORUM_MODAL_TYPES } from "constants/modal-types"
import { showForumModal, setForumCommentData } from "store/school/actions"

class Reviews extends Component {
  handleEdit = () => {
    const { onClickEdit = false } = this.props

    if (onClickEdit) {
      onClickEdit()
    }
  }

  handleEditCommentToAnswer = (comment) => {
    const { showForumModal, setForumCommentData } = this.props
    comment.commentToAnswer = true
    setForumCommentData(comment)

    showForumModal({
      type: FORUM_MODAL_TYPES.COMMENT,
      isEdit: true,
    })
  }
  render() {
    const {
      id,
      review,
      commentor,
      pubTimestamp,
      editTimestamp,
      type = "comment",
      upvotes = 0,
      downvotes = 0,
      isAuthor = false,
      acceptedAnswer = false,
      onClickUpvote,
      onClickDownvote,
      onClickAccept,
      isQuestionAuthor,
      isAnswered,
      showCommentForm,
      comments,
      addCommentToAnswer,
      color,
      voteStatus,
    } = this.props

    return (
      <div className={cx("review-item", isAnswered && "-answered")}>
        <div className="detail">
          <Avatar size="24" name={commentor} />
          <p className="user">{commentor}</p>
          <p className="date">{formatTimestamp(pubTimestamp)}</p>
          {editTimestamp && pubTimestamp !== editTimestamp ? (
            <Fragment>
              <ReactTooltip effect="solid" id="reviewCard" />
              <span
                className="edited"
                data-tip={formatTimestamp(editTimestamp)}
                data-for="reviewCard"
              >
                (edited)
              </span>
            </Fragment>
          ) : (
            ""
          )}
        </div>
        {isAuthor ? (
          <div className="review-options">
            <div className="options-icon">
              <span className="icon-exam" onClick={() => this.handleEdit()} />
            </div>
          </div>
        ) : (
          ""
        )}
        <p className={cx("review", isAuthor && "mr-m")}>{review}</p>
        {showCommentForm && !isEmpty(comments) && (
          <>
            {comments.map((comment, i) => {
              return (
                <Comment
                  key={`comment-${i}`}
                  author={comment?.user?.full_name}
                  comment={comment?.comment_text}
                  dateCreated={formatTimestamp(comment?.pub_date)}
                  handleEdit={() => this.handleEditCommentToAnswer(comment)}
                />
              )
            })}
          </>
        )}
        {showCommentForm && (
          <p className="comment-action" onClick={addCommentToAnswer}>
            add comment
          </p>
        )}

        {type === "answer" && (
          <div className="actions">
            <div className="upvotes">
              {isAuthor ? (
                <span className="icon-up" />
              ) : (
                <span
                  style={{
                    color: voteStatus === "up" && color,
                  }}
                  className="icon-up clickable"
                  onClick={onClickUpvote}
                />
              )}
              {upvotes} votes
            </div>
            <div className="downvotes">
              {isAuthor ? (
                <span className="icon-down" />
              ) : (
                <span
                  style={{
                    color: voteStatus === "down" && color,
                  }}
                  className="icon-down clickable"
                  onClick={onClickDownvote}
                />
              )}
              {downvotes} votes
            </div>
            {!isAnswered && isQuestionAuthor && (
              <div className="answer-mark">
                <CheckBox
                  text="Mark as answer"
                  onClick={onClickAccept}
                  value={acceptedAnswer}
                  defaultChecked={acceptedAnswer}
                  id={`chk-answer-${id}`}
                />
              </div>
            )}
          </div>
        )}
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      showForumModal,
      setForumCommentData,
    },
    dispatch
  )

export default compose(connect(null, mapDispatchToProps), withRouter)(Reviews)
